
















































































































import Api from "@/api/Api";
import { PublishmentLocality } from "@/interfaces/publishmentlocality";
import { PublishmentRegion } from "@/interfaces/publishmentregion";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";
import Vue from "vue";
import { mapActions, mapState } from "vuex";
export default Vue.extend({
  mixins: [AppFormLogicMixin],
  methods: {
    ...mapActions(["loadRegions"]),
    onComplete() {
      this.$router.push({
        name: "AdministratorAreasComplete",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async decoratePostData(postData: PublishmentLocality) {
      postData.region = ((postData.region || {}) as PublishmentRegion)["@id"];
      return postData;
    },
  },
  computed: {
    ...mapState(["regions"]),
    rawPostData(): PublishmentLocality {
      return this.locality;
    },
    validateUrl(): string {
      return "/api/adv/publishment_localities/validate";
    },
    execUrl(): string {
      return this.locality["@id"] || "";
    },
    execMethod() {
      return "put";
    },
  },
  data() {
    return {
      locality: {} as PublishmentLocality,
      isLoading: true,
      phase: "input",
      errors: {},
    };
  },
  async mounted() {
    await this.loadRegions();
    this.locality = await Api.singleton().call({
      method: "GET",
      resource: "/api/adv/publishment_localities/" + this.$route.params.id,
    });
    this.isLoading = false;
  },
});
